const { Component, render } = wp.element;

import { WTopDisplayBrands as Brands } from "./DisplayBrands";

// Instantiate for every brands on the page
document.addEventListener('DOMContentLoaded', function(event) {
  const posts = document.querySelectorAll('.wtop-brands-wrapper');

  for (let i = 0; i < posts.length; i++) {
    let attributes = JSON.parse(posts[i].getAttribute('data-attributes'));
    
    const {
      number_of_items,
      number_of_categories,
      border_color_category,
      border_color_brands,
      categories_to_be_showed,
      background_brands,
      text_color_brands
    } = attributes;

    render(
      <Brands 
        settings={{
          number_of_items: number_of_items,
          border_color_category: border_color_category,
          border_color_brands: border_color_brands,
          categories_to_be_showed: categories_to_be_showed,
          background_brands: background_brands,
          text_color_brands: text_color_brands,
          number_of_categories: number_of_categories
        }}
      />,
      posts[i]
    );
  }
});



// WEBPACK FOOTER //
// ./src/frontend.js